import React, { useState, useEffect } from "react";
import LSAreaChart from "../Graphs/LTStatisticsGraph/LSAreaChart";
import LSStackColChart from "../Graphs/LTStatisticsGraph/LSStackColChart";
import LSColLineChart from "../Graphs/LTStatisticsGraph/LSColLineChart";
import LSPaiChart from "../Graphs/LTStatisticsGraph/LSPaiChart";
import {
  DBStatistics,
  DownloadReportsTypes,
  sortingMethod,
} from "../../../../Containers/vendor/DashBoard/DBCosntants";

export interface ILTStatisticsProps {
  dbData: any;
  downloadDbReports: (rpTyp: string) => void;
}

const LTStatistics: React.FC<ILTStatisticsProps> = (props) => {
  const [loginData, setLoginData] = useState<Array<DBStatistics>>([]);
  const [uniqueOrdData, setUniqueOrdData] = useState<Array<DBStatistics>>([]);
  const [uniqueTradeData, setUniqueTradeData] = useState<Array<DBStatistics>>(
    []
  );
  const [uniqueOrdTrdData, setUniqueOrdTrdData] = useState<Array<DBStatistics>>(
    []
  );

  const handleDownloadBtn = () => {
    let rpTyp = DownloadReportsTypes.Login;
    props.downloadDbReports(rpTyp);
  };

  useEffect(() => {
    if (props.dbData && props.dbData.lgnChrt) {
      setLoginData(sortingMethod(props.dbData.lgnChrt));
    } else {
      setLoginData([]);
    }
    if (
      props.dbData &&
      (props.dbData.unqClntOrdCht ||
        props.dbData.unqClntTrdCht ||
        props.dbData.ordTradeRtoCht)
    ) {
      setUniqueOrdData(sortingMethod(props.dbData.unqClntOrdCht));
      setUniqueTradeData(sortingMethod(props.dbData.unqClntTrdCht));
      setUniqueOrdTrdData(sortingMethod(props.dbData.ordTradeRtoCht));
    } else {
      setUniqueOrdData([]);
      setUniqueTradeData([]);
      setUniqueOrdTrdData([]);
    }
  }, [props.dbData]);

  return (
    <div className="lt_Statistics">
      <div className="lt_Statistics_row_one">
        <div className="Graph_col lt_Statistics_col_one">
          <LSAreaChart
            loginData={loginData}
            handleDownloadBtn={handleDownloadBtn}
          />
        </div>
        <div className="Graph_col lt_Statistics_col_tow">
          <LSStackColChart
            uniqueOrdData={uniqueOrdData}
            uniqueTradeData={uniqueTradeData}
            handleDownloadBtn={handleDownloadBtn}
          />
        </div>
      </div>
      <div className="lt_Statistics_row_two">
        <div className="Graph_col lt_Statistics_col_three">
          <LSColLineChart
            uniqueOrdData={uniqueOrdData}
            uniqueTradeData={uniqueTradeData}
            uniqueOrdTrdData={uniqueOrdTrdData}
          />
        </div>
        <div className="Graph_col lt_Statistics_col_four">
          <LSPaiChart orderTradeRatioData={props.dbData} />
        </div>
      </div>
    </div>
  );
};

export default LTStatistics;
